import { get, post, put, del, postFile } from "./config";

export const login = async ({username,password}) => {
    const url = '/admin/user/erp-login';
    const data = {
        erpId: username,
        password
    };
    return await post(url,data);
};

export const addUser = async data => {
    const url = '/admin/user';
    return await post(url,data,true);
};

export const editUser = async data => {
    const url = '/admin/user';
    return await put(url,data,true);
};

export const addUserBatch = async file => {
    const url = '/admin/user/batch';
    const data = new FormData();
    data.append('usersFile',file);
    return await postFile(url,data,true);
};

export const getUserList = async ({page,size,tenantId,departmentIds,positionIds,statuses,authorities}) => {
    let url = `/admin/user/list?page=${page}&size=${size}`;
    if(departmentIds)url += `&departmentIds=${departmentIds}`;
    if(positionIds)url += `&positionIds=${positionIds}`;
    if(statuses)url += `&statuses=${statuses}`;
    if(authorities)url += `&authorities=${authorities}`;
    if(tenantId)url += `&tenantId=${tenantId}`;
    return await get(url,true);
};

export const deleteUsers = async ({userIds}) => {
    const url = `/admin/user?userIds=${userIds}`;
    return await del(url,true);
}

export const onlyUser = async ({phone}) => {
    let url = `/admin/userMp/onlyUser?phone=${phone}`;
    return await get(url,true);
};  